import { render } from "./DiagonalSection.vue?vue&type=template&id=21737753"
import script from "./DiagonalSection.vue?vue&type=script&lang=js"
export * from "./DiagonalSection.vue?vue&type=script&lang=js"

import "./DiagonalSection.vue?vue&type=style&index=0&id=21737753&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__